import { queryClient } from 'src/config/request'
import { useMutation } from 'src/lib/hooks'
import type { CommunityProps, EditCommunityProps } from 'src/modules/community/types'

import { CommunityEndpoints } from '../../constants'
import CommunityService from '../../service'

const useEditCommunity = ({ membershipSlug }) => {
  return {
    editCommunityQuery: useMutation<CommunityProps, EditCommunityProps>((payload) =>
      CommunityService.editCommunity(payload)
    ),
    invalidateEditQueries: () => {
      return Promise.all([
        queryClient.invalidateQueries([CommunityEndpoints.getGroupCommunities(membershipSlug)]),
        queryClient.invalidateQueries([CommunityEndpoints.getCommunities()])
      ])
    }
  }
}

export default useEditCommunity
